import React from 'react';
import './CommunityPlatformPolicies.css';

const CommunityPlatformPolicies = () => {
  return (
    <div className="policy-container">
      <h1 className="policy-title">Community & Platform Policies</h1>
      <p className="policy-date">Effective Date: May 24, 2025</p>

      <p className="policy-intro">
        We're a platform that connects independent home cooks with local buyers. We provide tools, not meals — meaning we don't cook, deliver, or sell any food ourselves. Instead, we focus on building a trusted space for safe, respectful, and self-managed food exchanges.
      </p>

      <section className="policy-section">
        <h2 className="policy-section-title">A. Our Role</h2>
        <div className="policy-content">
          <ul>
            <li>We're not a restaurant or vendor.</li>
            <li>We don't prepare or inspect food.</li>
            <li>We don't set prices or control what gets cooked.</li>
            <li>We build the digital infrastructure and uphold basic community standards — that's it.</li>
          </ul>
        </div>
      </section>

      <section className="policy-section">
        <h2 className="policy-section-title">B. For Chefs</h2>
        <div className="policy-content">
          <ul>
            <li>You are fully responsible for cleanliness, safety, and compliance with local laws.</li>
            <li>Upload real images of the food you're cooking — not faces, stock photos, or anything misleading.</li>
            <li>Accurately list ingredients and allergens.</li>
            <li>Fulfill orders reliably. Frequent cancellations may result in reduced visibility or removal.</li>
          </ul>
        </div>
      </section>

      <section className="policy-section">
        <h2 className="policy-section-title">C. For Buyers</h2>
        <div className="policy-content">
          <ul>
            <li>You're responsible for reading listings, checking allergens, and making informed orders.</li>
            <li>Always communicate respectfully and pick up your order on time (if applicable).</li>
            <li>If you have dietary needs or allergies, confirm with the cook directly before ordering.</li>
          </ul>
        </div>
      </section>

      <section className="policy-section">
        <h2 className="policy-section-title">D. Image & Content Rules</h2>
        <div className="policy-content">
          <ul>
            <li>Only upload food images — no people, faces, or unrelated items.</li>
            <li>We use automatic content moderation tools to help enforce this.</li>
            <li>Repeated violations may result in content removal or account suspension.</li>
          </ul>
        </div>
      </section>

      <section className="policy-section">
        <h2 className="policy-section-title">E. Shared Accountability</h2>
        <div className="policy-content">
          <ul>
            <li>We do not vet kitchens or enforce licenses unless required by law.</li>
            <li>Disputes between users should be resolved respectfully and directly.</li>
            <li>We reserve the right to remove accounts that harm community trust or violate these policies.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default CommunityPlatformPolicies;
